import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const postsEndpoint = process.env.VUE_APP_WP_ENDPOINT_POST
const categoriesEndpoint = process.env.VUE_APP_WP_ENDPOINT_CAT

const state = {
  appInitialized: false,
  loading: false,
  categories: [],
  posts: [],
  filteredPosts: [],
  selectedPost: null,
}

const getters = {
  categories: ({ categories }) => categories,
  posts: ({ posts }) => posts,
  filteredPosts: ({ filteredPosts }) => filteredPosts,
  selectedPost: ({ selectedPost }) => selectedPost,
}

const mutations = {
  SET_APP_INITIALIZED(state, flag) {
    state.appInitialized = flag
  },
  SET_LOADING(state, flag) {
    state.loading = flag
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_POSTS(state, posts) {
    state.posts = posts
  },
  SET_FILTERED_POSTS(state, filteredPosts) {
    state.filteredPosts = filteredPosts
  },
  SET_SELECTED_POST(state, selectedPost) {
    state.selectedPost = selectedPost
  },
}

const actions = {
  getPosts: ({ commit }, categoryId) => {
    let endpoint = postsEndpoint

    if (typeof categoryId === 'number') {
      endpoint += `&results_gallery_categories=${categoryId}`
    }

    commit('SET_LOADING', true)

    return axios.get(endpoint).then(({ data }) => {
      commit('SET_POSTS', data)
      commit('SET_LOADING', false)
    })
  },
  getCategories: ({ commit }) => {
    return axios.get(categoriesEndpoint).then(({ data }) => {
      commit('SET_CATEGORIES', data)
      commit('SET_APP_INITIALIZED', true)
    })
  },
}

export default new Vuex.Store({ state, getters, mutations, actions })
